// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--38F6g","buttonGhost":"button-module--button--ghost--1Eoqd","buttontext":"button-module--buttontext--Gc4uq"};